"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appearOnGivenPage = void 0;
/*to keep the odd/even page logic in one place */
const appearOnGivenPage = (printSide, value, pageNumber, subPageNumber, ignoredPubPages) => {
    if (printSide === 'even' &&
        pageNumber % 2 === 0 &&
        (!ignoredPubPages || !(ignoredPubPages === null || ignoredPubPages === void 0 ? void 0 : ignoredPubPages.includes(subPageNumber)))) {
        return value;
    }
    else if (printSide === 'odd' &&
        pageNumber % 2 !== 0 &&
        (!ignoredPubPages || !(ignoredPubPages === null || ignoredPubPages === void 0 ? void 0 : ignoredPubPages.includes(subPageNumber)))) {
        return value;
    }
    else if (printSide === 'all' &&
        (!ignoredPubPages || !(ignoredPubPages === null || ignoredPubPages === void 0 ? void 0 : ignoredPubPages.includes(subPageNumber)))) {
        return value;
    }
    return '';
};
exports.appearOnGivenPage = appearOnGivenPage;
//# sourceMappingURL=appearOnGivenPage.js.map